import React, { useEffect, useState } from 'react';

const EntryDoorg = () => {
  const [params, setParams] = useState({});

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const data = {};
    for (const [key, value] of query.entries()) {
      data[key] = value;
    }
    setParams(data);
    console.log('OAuth redirect received:', data);
  }, []);

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
      <h2>✅ OAuth Redirect Received</h2>
      <pre>{JSON.stringify(params, null, 2)}</pre>
    </div>
  );
};

export default EntryDoorg;